import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EditableDBItemV3, ModuleFE_Dialog, TS_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { filterInstances, MUSTNeverHappenException } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import './Dialog_MacroTagEditor.scss';
import { Component_MacroTagEditor } from '../Component_MacroTagEditor/Component_MacroTagEditor.js';
import { ModuleFE_MacroTag } from '../../../_entity.js';
export class Dialog_MacroTagEditor extends TS_Dialog {
    // ######################### Static #########################
    static show(macroTagId, editMode) {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_MacroTagEditor, { macroTagId: macroTagId, editMode: editMode }), closeOverlayOnClick: () => false });
    }
    static defaultProps = {
        dialogId: 'dialog__macro-tags-editor',
    };
    // ######################### Lifecycle #########################
    deriveStateFromProps(nextProps, state) {
        state.macroTag ??= this.getEditableMacro(nextProps.macroTagId);
        state.editMode = state.macroTag.item._id ? !!nextProps.editMode : true;
        return state;
    }
    // ######################### Logic #########################
    getEditableMacro(macroId) {
        if (!macroId)
            return new EditableDBItemV3({ tagGroups: [] }, ModuleFE_MacroTag)
                .setOnChanged(async (editable) => this.setState({ macroTag: editable }));
        const macroTag = ModuleFE_MacroTag.cache.unique(macroId);
        if (!macroTag)
            throw new MUSTNeverHappenException(`Could not get macro tag for id ${macroId}`);
        return new EditableDBItemV3(macroTag, ModuleFE_MacroTag)
            .setOnChanged(async (editable) => this.setState({ macroTag: editable }))
            .setAutoSave(true);
    }
    createNewMacroTag = async () => {
        const action = async () => {
            try {
                await this.state.macroTag.save();
                this.closeDialog();
            }
            catch (err) {
                this.logError(err);
            }
        };
        this.performAction(action);
    };
    deleteMacro = async () => {
        this.performAction(async () => {
            try {
                await this.state.macroTag.delete();
                this.closeDialog();
            }
            catch (err) {
                this.logError(err);
            }
        });
    };
    // ######################### Header #########################
    renderHeader = () => {
        const macroTag = this.state.macroTag.item;
        const title = !macroTag._id ? 'Create New Macro Tag' : `${this.state.editMode ? 'Edit' : 'View'} ${macroTag.label}`;
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'header__title', children: title }), _jsx(ICONS.x.component, { onClick: () => this.closeDialog() })] });
    };
    // ######################### Body #########################
    renderBody = () => {
        return _jsx(Component_MacroTagEditor, { editMode: this.state.editMode, editable: this.state.macroTag });
    };
    // ######################### Buttons #########################
    buttons = () => {
        const macroTag = this.state.macroTag.item;
        const editMode = this.state.editMode;
        return {
            right: filterInstances([
                (!macroTag._id ? { content: 'Cancel', onClick: () => this.closeDialog() } : undefined),
                (!macroTag._id ? {
                    content: 'Create New',
                    onClick: this.createNewMacroTag,
                } : undefined)
            ]),
            left: filterInstances([
                ((macroTag._id && editMode) ? {
                    content: 'Delete',
                    onClick: this.deleteMacro,
                } : undefined)
            ])
        };
    };
}
//# sourceMappingURL=Dialog_MacroTagEditor.js.map